import { Map } from 'immutable';
import bitbucket from './Bitbucket';
import compass from './Compass';
import confluence from './Confluence';
import jira from './Jira';
import chat from './Stride';
export const appConfig = Map({
  chat,
  jira,
  confluence,
  bitbucket,
  compass
});